// extracted by mini-css-extract-plugin
module.exports = {"option":"_DropdownSelect_option__1049X","dropdown":"_DropdownSelect_dropdown__3kRjK"};